import { MediaQuery as o } from "../../styles/variables.js";
import { styled as i, css as e } from "styled-components";
import { ImageZoom as d } from "../ImageZoom/index.js";
import { ModalHeader as t, ModalCloseButtonIcon as a } from "../Modal/style.js";
import { Theme as r } from "../../styles/themes/index.js";
const l = i.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`, g = i(d)`
  height: auto;
  width: 100%;

  @media ${o.SCREEN_MD_UP} {
    height: 100%;
    width: auto;
  }

  img {
    opacity: 0 !important; // force hide default image component
  }
`, c = e`
  padding: 0;
  height: 100%;
  width: 100%;
  bottom: unset;

  ${t} {
    position: absolute;
    width: 100%;
    top: 24px;
    padding: 0 24px;
    z-index: 1;
  }

  ${a} {
    background-color: rgb(${r.colors.Juliet});
    border-radius: 24px;
  }

  @media ${o.SCREEN_SM} {
    border-radius: 0;
  }

  @media ${o.SCREEN_MD_UP} {
    max-width: 960px;
    min-height: 512px;
    max-height: 684px;

    ${t} {
      position: absolute;
      width: 100%;
      top: 24px;
      padding: 0 32px;
      z-index: 1;
    }
  }
`;
export {
  l as Container,
  g as Image,
  c as modalStyle
};
